import productAPI from '@/app/apis/main/product/product-api.js';

export default {
    /**
	 * @return {object} product list
	 * @param {*} productDetails - Contains pagination data
	 * @param productId
	 */
	async getProducts(productDetails) {
		return productAPI.getProducts(productDetails);
    },

    /**
	 * @return {object} product details
	 * @param {*} productId - product id
	 */
	async getProductById(productId) {
		return productAPI.getProductById(productId);
    },

	/**
	 * @return {object} product types
	 * */
	async getProductTypes() {
		return productAPI.getProductTypes();
	}, 

	/**
	 * @return {object} product details
	 * @param {*} body - product id
	 */
	async getProductsByName(body) {
		return productAPI.getProductsByName(body);
	},

    /**
	 * @return no content
	 * @param {*} productDetails
	 */
	async postProducts(productDetails) {
		return productAPI.postProducts(productDetails);
    },

    /**
	 * @return no content
	 * @param {*} productDetails
	 * @param productId
	 */
	async putProduct(productId, productDetails) {
		return productAPI.putProduct(productId, productDetails);
    },

    /**
	 * @return no content
	 * @param {*} productDetails
	 * @param productId
	 */
	async reactivateProduct(productId) {
		return productAPI.reactivateProduct(productId);
    },

    /**
	 * @return no content
	 * @param productId
	 */
    async deleteProduct(productId) {
		return productAPI.deleteProduct(productId);
    },

	/**
	 * @return no content
	 * @param {*} productDetails
	 */
	async postOtherProducts(productDetails) {
		return productAPI.postOtherProducts(productDetails);
    },

	/**
	 * @return {object} dog product details
	 * @param {*} productId - product id
	 */
	async getProductDogById(productId) {
		return productAPI.getProductDogById(productId);
	},
	
	/**
	 * @return no content
	 * @param {*} productDetails
	 */
	async putOtherProducts(productId ,productDetails) {
		return productAPI.putOtherProducts(productId,productDetails);
    },
	
	/**
	 * @return no content
	 * @param productId
	 */
	async productDelete(productId) {
		return productAPI.productDelete(productId);
    },

	async postMultipleProducts(products) {
		return productAPI.postMultipleProducts(products);
    }
}